




























































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Borough } from "../model/Boroughs";
import {
  Gender,
  GetSelectedBorough,
  isNorthEastAndNorthCumbria
} from "../model/Model";

@Component
export default class DrinkCoachAppointment extends Vue {
  public static navButtonClasses: string[] = ["book-appointment"];
  public static navButtonLabel(region: Borough | undefined): string {
    if (
      (region && !!region.hasFreeAppointments) ||
      isNorthEastAndNorthCumbria()
    ) {
      return "Book a FREE online appointment with a DrinkCoach";
    }
    return "Book an online appointment with a DrinkCoach";
  }

  @Prop() public score!: number;
  @Prop() public units!: number;
  @Prop() public calories!: number;
  @Prop() public gender!: Gender;
  @Prop() public region!: Borough;
  @Prop() public commissioned!: boolean;
  @Prop() public isMobile!: boolean;

  public get hasFreeAppointments(): boolean {
    return !!this.region.hasFreeAppointments;
  }

  public get bookingLiveLink(): string {
    let name = this.region.name;
    if (GetSelectedBorough() === "Norfolk") {
      name = "Norfolk";
    }
    switch (name) {
      case "West Sussex":
        return "https://bookdrinkcoach.as.me/westsussex";
      case "Norfolk":
        return "https://bookdrinkcoach.as.me/norfolk";
      case "Rotherham":
        return "https://bookdrinkcoach.as.me/rotherham";
      case "Barnet":
        return "https://bookdrinkcoach.as.me/barnet";
      case "Lambeth":
        return "https://bookdrinkcoach.as.me/lambeth";
      case "Lewisham":
        return "https://bookdrinkcoach.as.me/lewisham";
      case "Haringey":
        return "https://bookdrinkcoach.as.me/haringey";
      case "Barnsley":
        return "https://bookdrinkcoach.as.me/barnsley";
      case "Croydon":
        return "https://bookdrinkcoach.as.me/croydon";
      case "Bradford District":
        return "https://bookdrinkcoach.as.me/bradford";
      case "Oxfordshire":
        return "https://bookdrinkcoach.as.me/oxfordshire";
      default:
        return "https://bookdrinkcoach.as.me/";
    }
  }
}
